export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('en-US').format(value)
}

export function formatPercent(value: number): string {
  return `${(value * 100).toFixed(1)}%`
}

export function clsx(...classes: (string | undefined | null | boolean)[]): string {
  return classes.filter(Boolean).join(' ')
}

export function cn(...inputs: (string | undefined | null | boolean)[]): string {
  return clsx(inputs)
}

const BRAND_CANONICAL: Record<string, string> = {
  'shea moisture': 'SheaMoisture',
  'shea moisturizer': 'SheaMoisture',
  sheamoisture: 'SheaMoisture',
}

export function canonicalBrandName(name: string | null | undefined): string {
  const trimmed = String(name ?? '').trim()
  if (!trimmed) {
    return ''
  }

  const normalized = trimmed.toLowerCase().replace(/\s+/g, ' ')
  return BRAND_CANONICAL[normalized] ?? trimmed
}

export function canonicalBrandKey(name: string | null | undefined): string {
  return canonicalBrandName(name).toLowerCase()
}

export function sanitizeNarrativeText(value: string | null | undefined): string {
  const raw = String(value ?? '').trim()
  if (!raw) {
    return ''
  }

  return raw
    .replace(/\([^)]*\bfollowers?\b[^)]*\)/gi, '')
    .replace(/(in the last \d+ days?):\s*(.+?)(\.(?:\s|$))/gi, (_match, prefix: string, names: string, terminator: string) => {
      const creatorCount = names
        .split(/,| and /i)
        .map((name) => name.trim())
        .filter((name) => name.length > 0).length

      if (creatorCount < 1) {
        return `${prefix}.${terminator.endsWith(' ') ? ' ' : ''}`
      }

      const summary = creatorCount === 1 ? '1 creator detected.' : `${creatorCount} creators detected.`
      return `${prefix}. ${summary}${terminator.endsWith(' ') ? ' ' : ''}`
    })
    .replace(/\b[@.]?[a-z0-9]*_[a-z0-9._]*\b/gi, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s+,/g, ',')
    .replace(/:\s*,/g, ':')
    .replace(/,{2,}/g, ',')
    .replace(/,\s*\./g, '.')
    .replace(/:\s*\./g, '.')
    .replace(/\.\s*\./g, '.')
    .replace(/:\s*$/g, '')
    .replace(/,\s*$/g, '')
    .replace(/\.\s+\./g, '.')
    .replace(/\s{2,}/g, ' ')
    .trim()
}

export function toSentence(value: string | null | undefined, fallback: string, maxChars = 110): string {
  const candidate = sanitizeNarrativeText(value) || fallback
  if (candidate.length <= maxChars) {
    return candidate
  }
  return `${candidate.slice(0, Math.max(0, maxChars - 1)).trimEnd()}…`
}
